var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "page-nav"
  }, [_c('div', {
    staticClass: "page-nav__col"
  }, [_vm.pagination.current + 1 <= _vm.pagination.count ? _c('Button', {
    staticClass: "page-nav__load-more",
    attrs: {
      "size": "49",
      "data-e2e": "page-nav-load-more"
    },
    on: {
      "click": function ($event) {
        return _vm.loadMore(_vm.pagination.current + 1);
      }
    }
  }, [_vm._v("\n      Еще " + _vm._s(_vm.totalQuantity) + " " + _vm._s(_vm.declinationValue) + "\n    ")]) : _c('Button', {
    staticClass: "page-nav__load-more",
    class: [{
      'page-nav__load-more_loaded': _vm.pagination.current === _vm.pagination.count
    }],
    attrs: {
      "disabled": "",
      "size": "49"
    }
  }, [_vm._v("\n      Всё загружено\n    ")])], 1), _vm._v(" "), _c('div', {
    staticClass: "page-nav__col page-nav__col_pagination"
  }, [_c('div', {
    staticClass: "page-nav__nav"
  }, [_c('div', {
    staticClass: "page-nav__arrow page-nav__arrow_left",
    class: {
      'page-nav__arrow_disabled': _vm.pagination.current === 1
    },
    on: {
      "click": function ($event) {
        _vm.pagination.current !== 1 && _vm.changePage(_vm.pagination.current - 1);
      }
    }
  }, [_c('nuxt-link', {
    staticClass: "link-icon link-icon_wu page-nav__arrow-wrap",
    attrs: {
      "to": _vm.pagination.current - 1 === 1 ? _vm.link ? _vm.link : '#' : ((_vm.link) + "PAGEN_1=" + (_vm.pagination.current - 1)),
      "tag": _vm.link && _vm.pagination.current !== 1 ? 'a' : 'div',
      "event": ""
    }
  }, [_c('div', {
    staticClass: "link-icon__icon-left-arrow"
  })])], 1), _vm._v(" "), _c('div', {
    staticClass: "page-nav__nums page-nav__nums_desktop"
  }, _vm._l(_vm.path, function (page, index) {
    return _c('nuxt-link', {
      key: index,
      staticClass: "page-nav__num",
      class: {
        'page-nav__num_active': page === _vm.pagination.current,
        'page-nav__num_passive': page === '...'
      },
      attrs: {
        "tag": !_vm.link || page === '...' ? 'div' : 'a',
        "to": index === 0 ? _vm.link ? _vm.link : '#' : ((_vm.link) + "PAGEN_1=" + page),
        "event": "",
        "data-e2e": "page-nav-num"
      },
      nativeOn: {
        "click": function ($event) {
          page !== '...' && _vm.changePage(+page);
        }
      }
    }, [_vm._v("\n          " + _vm._s(page) + "\n        ")]);
  }), 1), _vm._v(" "), _c('div', {
    staticClass: "page-nav__nums page-nav__nums_mobile"
  }, _vm._l(_vm.mobilePath, function (page, index) {
    return _c('nuxt-link', {
      key: index,
      staticClass: "page-nav__num",
      class: {
        'page-nav__num_active': page === _vm.pagination.current,
        'page-nav__num_passive': page === '...'
      },
      attrs: {
        "tag": !_vm.link || page === '...' ? 'div' : 'a',
        "to": index === 0 ? _vm.link ? _vm.link : '#' : ((_vm.link) + "PAGEN_1=" + page),
        "event": "",
        "data-e2e": "page-nav-num"
      },
      nativeOn: {
        "click": function ($event) {
          page !== '...' && _vm.changePage(+page);
        }
      }
    }, [_vm._v("\n          " + _vm._s(page) + "\n        ")]);
  }), 1), _vm._v(" "), _c('div', {
    staticClass: "page-nav__arrow page-nav__arrow_right",
    class: {
      'page-nav__arrow_disabled': _vm.pagination.current === _vm.pagination.count
    },
    on: {
      "click": function ($event) {
        _vm.pagination.current !== _vm.pagination.count && _vm.changePage(_vm.pagination.current + 1);
      }
    }
  }, [_c('nuxt-link', {
    staticClass: "link-icon link-icon_wu page-nav__arrow-wrap",
    attrs: {
      "tag": _vm.link && _vm.pagination.current !== _vm.pagination.count ? 'a' : 'div',
      "to": ((_vm.link) + "PAGEN_1=" + (_vm.pagination.current + 1)),
      "event": ""
    }
  }, [_c('div', {
    staticClass: "link-icon__icon-right-arrow"
  })])], 1)])])]);
}
var staticRenderFns = []

export { render, staticRenderFns }